import { render } from "./SearchDish.vue?vue&type=template&id=1de95968&scoped=true"
import script from "./SearchDish.vue?vue&type=script&lang=js"
export * from "./SearchDish.vue?vue&type=script&lang=js"

import "./SearchDish.vue?vue&type=style&index=0&id=1de95968&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de95968"]])

export default __exports__